<template>
  <div>
    <p>
      {{
        ft(featureName, 'reportingChannels.digitalReport.responseIngress', $t, {
          email
        })
      }}
    </p>
    <p v-if="email">
      {{
        ft(
          featureName,
          'reportingChannels.digitalReport.responseDescriptionEmailIncluded',
          $t,
          {
            organizationTitle: organizationFullName,
            email
          }
        )
      }}
    </p>
    <p v-else>
      {{
        ft(
          featureName,
          'reportingChannels.digitalReport.responseDescriptionEmailNotIncluded',
          $t,
          {
            organizationTitle: organizationFullName
          }
        )
      }}
    </p>
    <p class="text-bold my-5">
      <b>{{ ft(featureName, 'received.topWarning', $t) }}</b>
    </p>
    <followup-case-details
      :password="password"
      :case-name="caseName"
      :followup-url="followupUrl"
      :feature-name="featureName"
    />
    <b-row class="my-4">
      <b-alert :show="true" variant="default" class="px-0">
        <span class="text-info d-flex align-items-center">
          <i class="bi bi-info-circle-fill text-info fs-3 mx-3"></i>
          {{ ft(featureName, 'received.bottomWarning', $t) }}
        </span>
      </b-alert>
    </b-row>
  </div>
</template>

<script>
import FollowupCaseDetails from './FollowupCaseDetails.vue'
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'DigitalReportResponse',
  components: { FollowupCaseDetails },
  extends: LocalizableComponent,
  props: {
    organizationName: {
      type: String,
      required: true
    },
    followupUrl: {
      type: String,
      required: true
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    caseName: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: null,
      required: false
    },
    locale: {
      type: String,
      default: null,
      required: false
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  computed: {}
}
</script>
